import { waitForPageLoadAnalytics } from "./pageLoad";

let pageLoadTrackingSent = false;

waitForPageLoadAnalytics
  .then(() => {
    pageLoadTrackingSent = true;
  })
  .catch(() => {
    // Silently handle page load analytics error
  });

export const hasPageLoadFired = () => pageLoadTrackingSent;
